import React from "react";
import { GoogleMap, Marker, useJsApiLoader } from "@react-google-maps/api";

/**
 * MapComponent
 * Props:
 * - center: { lat, lng } (default: Illinois State University)
 * - marker: { lat, lng } (default: center)
 * - width: CSS width (default: 200)
 * - height: CSS height (default: 140)
 * - zoom: number (default: 15)
 */
function MapComponent({
  center = { lat: 40.51076, lng: -88.99346 },
  marker = null,
  width = 200,
  height = 140,
  zoom = 15,
  style = {},
  ...props
}) {
  const { isLoaded } = useJsApiLoader({
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY || "",
  });
  return (
    <div style={{ width, height, borderRadius: 8, background: '#eee', ...style }}>
      {isLoaded && (
        <GoogleMap
          mapContainerStyle={{ width: '100%', height: '100%', borderRadius: 8 }}
          center={center}
          zoom={zoom}
          {...props}
        >
          <Marker position={marker || center} />
        </GoogleMap>
      )}
    </div>
  );
}

export default MapComponent;
